import { render, staticRenderFns } from "./McaDiagnostic.vue?vue&type=template&id=9e46239a&scoped=true"
import script from "./McaDiagnostic.vue?vue&type=script&lang=ts"
export * from "./McaDiagnostic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e46239a",
  null
  
)

export default component.exports